import React, { useState } from "react";
import SectionAbout from "../../components/Home/SectionAbout";
import Article from "../../components/Home/Article";
import MeetTheTeam from "../../components/Home/MeetTheTeam";

const About = () => {
  return (
    <div>
      {/* SectionAbout */}
      <SectionAbout />
      {/* Article */}
      <Article />
      {/* MeetTheTeam */}
      <MeetTheTeam />
    </div>
  );
};

export default About;
